import type { InventoryInformationEditView } from "@slfinrtl/ui-bff-routes"
import { useMemo } from "react"
import { useConfig } from "src/hooks"

export const useMinimumSubsidizedUsageTime = (view: InventoryInformationEditView) => {
	const { subsidizedUsage } = useConfig()

	const hasMinimumSubsidizedUsageTime = useMemo(
		() => !!view.subsidized && subsidizedUsage.minimumSubsidizedUsageTime !== undefined,
		[view.subsidized, subsidizedUsage.minimumSubsidizedUsageTime],
	)

	const subsidizedUsageCannotBeTerminated = useMemo(
		() =>
			hasMinimumSubsidizedUsageTime &&
			view.usageTime !== undefined &&
			subsidizedUsage.minimumSubsidizedUsageTime !== undefined &&
			view.usageTime < subsidizedUsage.minimumSubsidizedUsageTime &&
			!view.hasMarketPermissions &&
			subsidizedUsage.endUsageDespiteUnsufficientUsageTimePossible === false,
		[
			hasMinimumSubsidizedUsageTime,
			subsidizedUsage.minimumSubsidizedUsageTime,
			subsidizedUsage.endUsageDespiteUnsufficientUsageTimePossible,
			view.usageTime,
			view.hasMarketPermissions,
		],
	)

	return { hasMinimumSubsidizedUsageTime, subsidizedUsageCannotBeTerminated }
}
